module Meevo.Plugins.Register {
    "use strict";

    export class SpecifyClientSection extends Meevo.Plugins.Register.RegisterSectionBase {
        public registerClientNoun: Model.NounEnum = Model.NounEnum.RegisterClient;

        get $q() { return this.registerContext.$q; }

        get endPoints() { return this.registerContext.appSettings.API_ENDPOINTS; }
        get modalService() { return this.registerContext.modalService; }
        get dataService() { return this.registerContext.dataService; }
        get securityService() { return this.registerContext.securityService; }
        get busyService() { return this.registerContext.busyService; }
        get $translate() { return this.registerContext.$translate; }

        constructor(registerContext: Meevo.Plugins.Register.RegisterContext) {

            super(RegisterSectionTypeEnum.Client, registerContext, "specifyClient", Register.RegisterSectionCatTypeEnum.Other);

            this.appointmentSelection = {};

            this.clientWithAppointmentsToday = new Meevo.Components.BaseClasses.PagedResults(
                this.dataService,
                "clientAppointment"
            );

            this.cancelledOrNoShowAppointmentSelection = {};

            this.cancelledOrNoShowAppointments = new Meevo.Components.BaseClasses.PagedResults(
                this.dataService,
                "cancelNoShowAppointmentService",
                null,
                null,
                null,
                (count, response) => this.cancelledOrNoShowAppointmentsPostProcess(count, response, this)
            );
        }

        protected saleLine: Model.SaleLine;
        public clientWithAppointmentsToday: any;
        public appointmentSelection: {};
        numberOnHold: number;
        numberSelfPay: number;
        numberCancelNoShow: number = 0;
        showRecoveryHolds: boolean = true;
        showCancelNoShow: boolean = false;
        cancelledOrNoShowAppointments: any;
        cancelledOrNoShowAppointmentSelection: {};
        onHoldSearchResults: any;
        showOnHold: boolean;
        insertedNoShow = {
            id: null,
            displayName: "",
        };
        onlineBookingCancellation = {
            id: Model.CancellationTypeEnum.OnlineBookingCancellation,
            displayName: ''
        };
        populateFromAppointments: boolean = false;
        readonly sortAppointmentsTodayByClient: string = 'Client';
        readonly sortAppointmentsTodayByStartDateTime: string = 'StartDateTime';
        readonly SELF_PAYMENT_HOURS_LEFT_THRESHOLD: number = 8;
        sortByAppointmentsToday: string = this.sortAppointmentsTodayByStartDateTime;

        addAnonymousMaleClient() {
            if (this.isAnonymousClientDisabled()) {
                return;
            }
            this.addAnonymousClient(Model.ClientTypeEnum.AnonymousMale);
        }

        addAnonymousFemaleClient() {
            if (this.isAnonymousClientDisabled()) {
                return;
            }
            this.addAnonymousClient(Model.ClientTypeEnum.AnonymousFemale);
        }

        addAnonymousOtherClient() {
            if (this.isAnonymousClientDisabled()) {
                return;
            }
            this.addAnonymousClient(Model.ClientTypeEnum.AnonymousOther);
        }

        isClient(clientType: Model.ClientTypeEnum) {
            return clientType === Model.ClientTypeEnum.Client;
        }

        private isPastTransactionMode(): boolean {
            return (
                this.registerContext &&
                this.registerContext.registerTicketService &&
                this.registerContext.registerTicketService.isPastTransactionMode
            );
        }

        isAppointmentsTodayDisabled(): boolean {
            if (this.registerContext.editSelectedClient) {
                return true;
            }

            if (this.isPastTransactionMode()) {
                return true;
            }

            return false;
        }

        isReturnTransactionDisabled(): boolean {
            if (this.registerContext.editSelectedClient) {
                return true;
            }

            if (this.isPastTransactionMode()) {
                return true;
            }

            return false;
        }

        isRefundTransactionDisabled(): boolean {
            if (this.isPastTransactionMode()) {
                return true;
            }

            return false;
        }

        isCancelNoShowDisabled(): boolean {
            if (this.registerContext.editSelectedClient) {
                return true;
            }

            if (this.isPastTransactionMode()) {
                return true;
            }

            return false;
        }

        isAnonymousClientDisabled(): boolean {
            if (this.isPastTransactionMode()) {
                return true;
            }

            return false;
        }

        isAnonymousMaleClient(clientType: Model.ClientTypeEnum) {
            return clientType === Model.ClientTypeEnum.AnonymousMale;
        }

        isAnonymousFemaleClient(clientType: Model.ClientTypeEnum) {
            return clientType === Model.ClientTypeEnum.AnonymousFemale;
        }

        isAnonymousOtherClient(clientType: Model.ClientTypeEnum) {
            return clientType === Model.ClientTypeEnum.AnonymousOther;
        }

        isAnonymousClient(clientType: Model.ClientTypeEnum){
               return clientType == Model.ClientTypeEnum.AnonymousFemale
                   || clientType == Model.ClientTypeEnum.AnonymousMale
                   || clientType == Model.ClientTypeEnum.AnonymousOther
        }

        addAnonymousClient(clientType: Model.ClientTypeEnum) {
            if (!this.registerContext.sale) {
                return;
            }

            if (this.registerContext.editSelectedClient) {
                var newClient = new RegisterClient({ clientType: clientType });
                this.registerContext.sale.changedClientIds = [{
                    newClient: newClient,
                    oldClient: {
                        clientId: (this.registerContext.selectedClientType === Model.ClientTypeEnum.Client) ? this.registerContext.selectedClient.id : null,
                        clientType: this.registerContext.selectedClientType,
                        appointmentId: this.registerContext.selectedClientAppointmentId
                    }
                }];

                this.editClient(newClient);
            }
            else {
                this.registerContext.sale.changedClientIds = [];
            }

            this.processClientChange(undefined, clientType);
            this.registerContext.recalculateSale();
        }

        clientChanged() {
            if (!this.registerContext.sale) {
                return;
            }

            this.registerContext.clearSaleSyncAppointmentUpdates();
            this.populateFromAppointments = false;
            if (this.registerContext.editSelectedClient) {
                this.registerContext.sale.changedClientIds = [{
                    newClient: {
                        clientId: this.registerContext.payingClient.id,
                        clientType: Meevo.Model.ClientTypeEnum.Client,
                        appointmentId: null
                    },
                    oldClient: {
                        clientId: (this.registerContext.selectedClientType === Model.ClientTypeEnum.Client) ? this.registerContext.selectedClient.id : null,
                        clientType: this.registerContext.selectedClientType,
                        appointmentId: this.registerContext.selectedClientAppointmentId
                    }
                }];

                if (this.registerContext.sale.changedClientIds[0].newClient.clientId === this.registerContext.sale.changedClientIds[0].oldClient.clientId) {
                    // Client didn't actually change so remove it from change list.  This probably was the result of editing the client details.
                    this.registerContext.sale.changedClientIds.splice(0, 1);
                    let matchingClient = this.registerContext.getRegisterClient({ client: this.registerContext.selectedClient, clientType: this.registerContext.selectedClientType }, _.find);
                    if (matchingClient) {
                        this.registerContext.selectedClient = this.registerContext.payingClient;
                        matchingClient.client = this.registerContext.payingClient;
                    }
                }
            }
            else {
                this.registerContext.sale.changedClientIds = [];
            }

            let selectSection = device.portrait() ? RegisterSectionTypeEnum.Ticket : undefined;
            if (this.registerContext.selectedClientType !== Meevo.Model.ClientTypeEnum.Client
                || (!this.registerContext.payingClient && this.registerContext.selectedClient)
                || (this.registerContext.payingClient && !this.registerContext.selectedClient)
                || (this.registerContext.payingClient && this.registerContext.payingClient.id != this.registerContext.selectedClient.id)
            ) {
                if (this.registerContext.payingClient) {
                    this.registerContext.sale.mergeClientIds = [ this.registerContext.payingClient.id ];
                }
                return this.registerContext.getClientCombinedAfterActions([ this.registerContext.payingClient ], this.registerContext.sale)
                    .then(() => {
                        this.registerContext.recalculateSale(false, selectSection);
                    });
            }
            else if (this.registerContext.selectedClientType === Meevo.Model.ClientTypeEnum.Client
                && !this.registerContext.payingClient
                && !this.registerContext.selectedClient
                && this.registerContext.payingClient.id == this.registerContext.selectedClient.id
            ) {
                // client was edited in maintenance form
                this.registerContext.selectedClient = this.registerContext.payingClient;

                let matchingClient = this.registerContext.getRegisterClient({
                    client: this.registerContext.selectedClient,
                    clientType: this.registerContext.selectedClientType
                }, _.find);

                if (matchingClient) {
                    matchingClient.client = this.registerContext.selectedClient;
                }

                return this.registerContext.getClientCombinedAfterActions([ this.registerContext.payingClient ]).then(() => {
                    this.registerContext.recalculateSale(false, selectSection);
                });
            }

            if (this.registerContext.payingClient) {
                this.registerContext.payingClient.clientAlerts = [];
                this.checkForClientMissingFieldAlert(this.registerContext.payingClient.id, this.registerContext.payingClient.clientAlerts);
            }

            if (!_.isUndefined(this.registerContext.allUniqueClients[0]) && this.registerContext.allUniqueClients[0].client) {
                console.log(this.registerContext.allUniqueClients[0].expandAlerts);
            }
        }

        processClientMerge(salePrevious: Model.Sale, sale: Model.Sale = null) {
            // Only need to do this when coming from the client changed workflow
            if (!this.registerContext.payingClient) {
                return this.$q.resolve();
            }

            const newClient = new RegisterClient({
                clientType: Meevo.Model.ClientTypeEnum.Client,
                client: this.registerContext.payingClient
            });

            const newSaleLine = _.find(sale ? sale.saleLines : [], (saleLine: Model.SaleLine) =>
                saleLine.clientType === Meevo.Model.ClientTypeEnum.Client &&
                saleLine.client.id == this.registerContext.payingClient.id
            );

            if (sale && newSaleLine && newSaleLine.client) {
                newClient.client = newSaleLine.client;
                if (newClient.client.clientIdCheckedForMembership && newClient.client.clientIdCheckedForMembership == newClient.client.id) {
                    newClient.clientIdCheckedForMembership = newClient.client.id;
                }
            }

            const isEditing = this.registerContext.editSelectedClient &&
                (this.registerContext.selectedClient != this.registerContext.payingClient);

            const clientHasAppointmentServices = (sale: Model.Sale, clientId): boolean => {
                return _(sale.saleLines).any((saleLine) =>
                    saleLine.clientId == clientId &&
                    this.registerContext.isSaleLineAService(saleLine) &&
                    (<Model.ServiceSaleLineItem>saleLine.item).appointmentServiceId != undefined
                );
            }

            // Don't check for appointment if client already has an appointment assigned.  One case of this will be when implicitly merging a hold
            if (!clientHasAppointmentServices(sale, this.registerContext.payingClient.id) && !this.registerContext.editSelectedClient) {
                return this.checkClientForAppointments(newClient, !isEditing, sale.pastTransactionDateTime)
                    .then(() => {
                        this.registerContext.isPopulatingTicketFromAppointmentServices = false;
                        this.processClientChange(newClient.client, newClient.clientType);
                    });
            } else {
                return this.promptForServicesRelatedToImplicitlyAddAppointmentServiceSaleLines(salePrevious, sale).then(() => {
                    if (this.registerContext.editSelectedClient) {
                        this.editClient(newClient);
                    }
                    this.processClientChange(newClient.client, newClient.clientType);
                });
            }
        }

        promptForServicesRelatedToImplicitlyAddAppointmentServiceSaleLines(salePrevious: Model.Sale, sale: Model.Sale): angular.IPromise<any> {
            let newServiceSaleLineAppointmentServiceIds = [];
            let clientsWithAppointmentServiceSaleLines = {};
            this.getImplicitlyAddedAppointmentServiceSaleLines(salePrevious, sale, newServiceSaleLineAppointmentServiceIds, clientsWithAppointmentServiceSaleLines);

            if (newServiceSaleLineAppointmentServiceIds.length === 0) {
                //at this point all the rounds to get additional Clients/appointment services should be done, but last recalculateSale() doesn't hit showAccumulatedNotes = true setting NOT to trigger showClientNotes(), so if there are any App or Client Notes, it's time to show it
                return this.registerContext.showRebookCandidates().then(() => {
                    return this.registerContext.getClientCombinedAfterActions(undefined, sale);
                });
            }

            // Get the appointment services associated with any implicitly added appointment service sale lines.  Then determine if there's
            // other clients for those services that are not on the ticket and prompt user if they want to add those clients.
            return this.fetchAppointments(newServiceSaleLineAppointmentServiceIds, [], sale.pastTransactionDateTime)
                .then((appointmentServices: any[]) => {
                    let appointmentIds = [];
                    let confirmPromises = [];
                    let confirmedRelatedServices = [];

                    newServiceSaleLineAppointmentServiceIds.forEach((appointmentServiceId) => {
                        let appointmentService: any = _(appointmentServices).findWhere({ id: appointmentServiceId });

                        if (appointmentService && appointmentIds.indexOf(appointmentService.appointmentId) === -1) {
                            appointmentIds.push(appointmentService.appointmentId);

                            let relatedServices = _(appointmentServices).filter(
                                (appointmentServiceInner: Model.AppointmentService) => {
                                    if (appointmentService.appointmentId == appointmentServiceInner.appointmentId) {
                                        if (appointmentServiceInner.clientId) {
                                            if (clientsWithAppointmentServiceSaleLines[appointmentService.appointmentId]
                                                .clientIds.indexOf(appointmentServiceInner.clientId) === -1) {
                                                return true;
                                            }
                                        } else if (clientsWithAppointmentServiceSaleLines[appointmentService.appointmentId]
                                            .clientTypes.indexOf(appointmentServiceInner.clientType) === -1) {
                                            return true;
                                        }
                                    }
                                    return false;
                                });

                            let msg = this.createPromptForRelatedServices(appointmentService, relatedServices);
                            if (msg) {
                                confirmPromises.push(() => this.$q((resolve) => {
                                    this.modalService.confirmHandler(msg, Components.Modal.ModalTranslationModes.AsHtml)
                                        .then((responseIsYes) => {
                                            if (responseIsYes) {
                                                confirmedRelatedServices.push(...relatedServices);
                                            }
                                            resolve(true);
                                        });
                                }));
                            }
                        }
                    });
                   
                    confirmPromises.reduce((previousPromise, promise) => previousPromise.then(() => promise()),
                        this.$q.resolve()).then(() => {
                        if (confirmedRelatedServices.length > 0) {
                            const result = this.getCheckOutDetailsFromServices(confirmedRelatedServices);
                            this.addSelectedAppointmentsToRegister(result.checkOutServices, result.checkOutDetails);
                        } else {
                            return this.registerContext.showRebookCandidates().then(() => {
                                return this.registerContext.getClientCombinedAfterActions(undefined , sale);
                            });
                        }
                    });
                    this.registerContext.isPopulatingTicketFromAppointmentServices = false;
                });
        }

        private getImplicitlyAddedAppointmentServiceSaleLines(salePrevious: Model.Sale, sale: Model.Sale, newServiceSaleLineAppointmentServiceIds: any[], clientsWithAppointmentServiceSaleLines) {
            for (const saleLine of sale.saleLines) {
                if (!this.registerContext.isSaleLineAService(saleLine)) {
                    continue;
                }

                var saleLineServiceItem = (saleLine.item as Model.ServiceSaleLineItem);
                if (!saleLineServiceItem.appointmentServiceId) {
                    continue;
                }

                // A new appointment service sale line has been implicitly added
                let isImplicitlyAdded = _(salePrevious.saleLines).any((previousSaleLine: Model.SaleLine) => {
                    if (previousSaleLine.isNew) {
                        return false;
                    }

                    if (!this.registerContext.isSaleLineAService(previousSaleLine)) {
                        return false;
                    }

                    return true;
                });

                if (isImplicitlyAdded) {
                    return;
                }

                if (!clientsWithAppointmentServiceSaleLines[saleLineServiceItem.appointmentId]) {
                    clientsWithAppointmentServiceSaleLines[saleLineServiceItem.appointmentId] = {
                        clientIds: [],
                        clientTypes: []
                    }
                }

                if (saleLine.clientId) {
                    clientsWithAppointmentServiceSaleLines[saleLineServiceItem.appointmentId].clientIds.push(saleLine.clientId);
                } else {
                    clientsWithAppointmentServiceSaleLines[saleLineServiceItem.appointmentId].clientTypes.push(saleLine.clientType);
                }

                newServiceSaleLineAppointmentServiceIds.push(saleLineServiceItem.appointmentServiceId);
            }
        }

        processClientChange(clientObj: any, clientType: Meevo.Model.ClientTypeEnum) {
            let clientSelector: string;
            let smartTicketSelector: string;
            this.registerContext.addToAllUniqueClients(clientObj, clientType, undefined);
            this.registerContext.selectClient({ client: clientObj, clientType: clientType }, true);

            // after the client is added, if its out of view, scroll to it
            smartTicketSelector = 'smart-ticket-content';
            clientSelector = '#client-row-' + (this.registerContext.allUniqueClients.length - 1).toString();
            this.registerContext.scrollToElementOutOfView(smartTicketSelector, clientSelector);

            if (device.mobile() || (device.portrait() && device.tablet() && !device.largeTablet())) {
                //mobile navigation flow
                //mobile device or ipad in portrait
                this.registerContext.selectSection(RegisterSectionTypeEnum.Ticket);
            } else {
                this.registerContext.gotoNextSection();
            }
            this.registerContext.payingClient = undefined;
            this.registerContext.editSelectedClient = false;
            this.populateFromAppointments = false;
        }

        processClientHasAppointmentsTodayResponse(response, newClient, data, isAdd?: boolean) {
            if (response.choice == 1 || response.choice == 2) { // 1 = add services to client; 2 = replace *only* services
                //prompt if there are related appointment services returned
                let appointmentService: any = _.findWhere(data, { clientId: newClient.client.id });
                if (appointmentService) {
                    let promise: ng.IPromise<any>;
                    let selectedAppointmentServices: any[] = _.where(data, { clientId: appointmentService.clientId, clientType: appointmentService.clientType });
                    // get all unique appointment Ids for the selected services
                    let appointmentIds: string[] = _.uniq(_.pluck(selectedAppointmentServices, "appointmentId"));
                    let relatedAppointmentServices: any[] = this.getRelatedUnselectedAppointmentServices(data, appointmentIds, appointmentService.clientId, appointmentService.clientType);
                    let msg = this.createPromptForRelatedServices(appointmentService, relatedAppointmentServices);
                    if (msg) {
                        promise = this.modalService.confirmHandler(msg, Components.Modal.ModalTranslationModes.AsHtml).then((responseIsYes) => {
                            if (responseIsYes) {
                                $.merge(selectedAppointmentServices, relatedAppointmentServices);
                            }
                        });
                    }
                    else {
                        promise = this.$q.resolve();
                    }

                    return promise.then(() => {
                        if (!isAdd) {
                            if (response.choice == 2) {
                                let rClient = new RegisterClient({
                                    client: this.registerContext.selectedClient,
                                    clientType: this.registerContext.selectedClientType,
                                    appointmentId: this.registerContext.selectedClientAppointmentId
                                });

                                this.registerContext.removeAllSaleItems(rClient, true);
                            }

                            this.editClient(newClient, appointmentService.appointmentId);
                        }

                        const result = this.getCheckOutDetailsFromServices(selectedAppointmentServices);

                        this.registerContext.populateFromAppointmentServices(result.checkOutServices, result.checkOutDetails);
                        this.populateFromAppointments = true;

                        return appointmentService.appointmentId;
                    });
                }
            }
            else {
                // response.choice == 3; add/replace the client only
                if (!isAdd) {
                    this.editClient(newClient);
                }
                return null;
            }
        }

        checkClientForAppointments(newClient, isAdd?: boolean, pastTransactionDateTime?: Date) {
            return this.fetchAppointments([], [newClient.client.id], pastTransactionDateTime).then((services: any[]) => {
                // filter data of appointment services that's already in the sale
                let data: any[] = _.filter(services, (service: any) => {
                    return _.find(this.registerContext.sale.saleLines, (sl) => {
                        return sl.saleType == Meevo.Model.SalesTypeEnum.Service
                            && service.id == (sl.item as ServiceSaleLineItem).appointmentServiceId;
                    }) == null;
                });

                if (data.filter(service => service.clientId === newClient.client.id).length > 0) {
                    let modalOptions: Meevo.Components.Modal.IModalOptions = {
                        templateUrl: "app/plugins/register/specifyClient/clientChangePromptTemplate.html",
                        controller: "meevo.plugins.register.ClientChangePromptController",
                        controllerAs: "vm",
                        bindToController: true,
                        locals: {
                            isAdding: isAdd
                        }
                    };

                    if (isAdd) {
                        const message = this.getAddWithAppointmentMessage("MESSAGE_REGISTER_CLIENT_ADD_WITH_APPT");

                        return this.modalService.confirmHandler(message)
                            .then((confirmResponsee: boolean) => {
                                const response = {
                                    choice: confirmResponsee ? 1 : 3
                                };
                                return this.processClientHasAppointmentsTodayResponse(response, newClient, data, isAdd);
                            });
                    } else {
                        return this.modalService.showCustom(modalOptions)
                            .then((response) => {
                                return this.processClientHasAppointmentsTodayResponse(response, newClient, data, isAdd);
                            });
                    }
                }
                else {
                    if (!isAdd) {
                        this.editClient(newClient);
                    }
                    return null;
                }
            });
        }

        editClient(newClient, appointmentId?: string) {
            // sale line client have already been changed on the server-side logic
            let clientToMatch = new RegisterClient({
                client: this.registerContext.selectedClient,
                clientType: this.registerContext.selectedClientType,
                appointmentId: this.registerContext.selectedClientAppointmentId
            });
            var editClientIndex = this.registerContext.getRegisterClient(clientToMatch, _.findIndex);
            var removeClientIndex = this.registerContext.getRegisterClient(newClient, _.findIndex);

            if (editClientIndex > -1) {
                this.registerContext.allUniqueClients.splice(editClientIndex, 1, newClient);
            }
            if (removeClientIndex > -1) {
                this.registerContext.allUniqueClients.splice(removeClientIndex, 1);
            }
            this.registerContext.clientChangedUpdateRefundTips();
            this.registerContext.editSelectedClient = false;
        }

        fetchAppointments(appointmentServiceIds: string[], clientIds: string[], pastTransactionDateTime: Date) {
            let promiseToGetCancelledOrNoShows = this.getClientsCancelledOrNoShowAppointmentsToday(clientIds, pastTransactionDateTime);

            return promiseToGetCancelledOrNoShows.then((cancelledOrNoShowAppts: any[]) => {
                const startDate = pastTransactionDateTime 
                    ? moment(pastTransactionDateTime).startOf('day')
                    : moment().startOf('day');

                const request = {
                    appointmentServiceIds: appointmentServiceIds,
                    clientIds: clientIds,
                    finalStates: [Meevo.Model.AppointFinalStateEnum.None],
                    startDate: startDate.format("YYYY-MM-DD")
                };

                return this.dataService.customMethodData("/api/clientAppointmentServices/list", 'POST', request).then((response) => {
                    let appointmentServices: any[] = _(response.data)
                        .filter((appointmentService: any) => appointmentService.transitionState !== Meevo.Model.AppointStateEnum.NoShow)
                        .concat(cancelledOrNoShowAppts);

                    return appointmentServices;
                });
            });
        }

        gotoAppointmentsToday() {
            if (this.registerContext.editSelectedClient) {
                return;
            }
            if (this.isAppointmentsTodayDisabled()) {
                return;
            }

            this.registerContext.showToday = true;

            return this.getAllClientAppointmentsToday();
        }

        getAllClientAppointmentsToday()
        {
            let request = {
                pageNumber: 0,
                itemsPerPage: 30,
                sortDirection: Model.SortDirection.Ascending,
                sortBy: this.sortByAppointmentsToday,
                criteria: {
                    includeActive: true,
                    startDate: moment().format("YYYY-MM-DD"),
                    endDate: moment().add("days", 1).format("YYYY-MM-DD"),
                    finalStates: [Meevo.Model.AppointFinalStateEnum.None]
                }
            }
            this.clientWithAppointmentsToday.initSearch(request);
            this.appointmentSelection = {};
        }

        private getAddWithAppointmentMessage(contentKey: string): string {
            let onDate: string;

            if (this.registerContext.registerTicketService.isPastTransactionMode) {
                const dateFilter: any = this.registerContext.$filter("meevoDateFilter");
                const pastDate = this.registerContext.registerTicketService.getPastTransactionContext().pastTransactionDateTime;
                onDate = this.$translate.instant("MESSAGE_REGISTER_CLIENT_ADD_ON") + ' ' + dateFilter(pastDate);
            } else {
                onDate = this.$translate.instant("MESSAGE_REGISTER_CLIENT_ADD_TODAY");
            }

            return this.$translate.instant(contentKey, { onDate });
        }

        autoAddExistingServices(saleLines: Model.SaleLine[]) {
            if (this.registerContext.registerTicketService.isPastTransactionMode) {
                return false;
            }

            return !(saleLines.find(saleLine => saleLine.saleType === Model.SalesTypeEnum.ServiceNoShowFee ||
                saleLine.saleType === Model.SalesTypeEnum.ServiceCancellationFee ||
                (saleLine.saleType === Model.SalesTypeEnum.DepositCredit && saleLine.isRefund)));
        }

        handleOnHoldNoLinkMerge(sale: Model.Sale, clientIds: any[], skipAutoAddExistingServices = false) {
            // If there's only the one client id and its also a merge client id which would have been added during checkout, then treat this
            // as a checkout so there's no need to prompt about the other appointment services for the client
            if (!skipAutoAddExistingServices && clientIds.length == 1 && sale.mergeClientIds && sale.mergeClientIds.indexOf(clientIds[0]) >= 0 && 
                this.autoAddExistingServices(sale.saleLines)) {
                
                    return this._addSelectedClientAppointments([], clientIds);
            }
            else {
                const contentKey = clientIds.length > 1
                    ? "MESSAGE_REGISTER_CLIENTS_ADD_WITH_APPT"
                    : "MESSAGE_REGISTER_CLIENT_ADD_WITH_APPT";

                const message = this.getAddWithAppointmentMessage(contentKey);
               
                return this.modalService.confirmHandler(message, Meevo.Components.Modal.ModalTranslationModes.DoNotTranslate)
                    .then((confirmResponsee: boolean) => {
                        if (confirmResponsee) {
                            return this._addSelectedClientAppointments([], clientIds, sale.pastTransactionDateTime);
                        }
                        this.registerContext.isPopulatingTicketFromAppointmentServices = false;
                    });

            }
        }

        private _addSelectedClientAppointments(appointmentServiceIds: string[], clientIds: string[], pastTransactionDateTime?: Date) {
            if (appointmentServiceIds.length > 0 || clientIds.length > 0) {
                var servicesToBeAdded: any[] = [];

                return this.fetchAppointments(appointmentServiceIds, clientIds, pastTransactionDateTime).then((services: any[]) => {
                    let promises: ng.IPromise<void>[] = [];

                    //need to ensure if client has already been asked to be included for the same appointment
                    var clientsAsked: any[] = [];

                    //prompt if there are related appointment services returned
                    appointmentServiceIds.forEach((item) => {
                        let service: any = _.findWhere(services, { id: item });
                        if (service) {
                            let selectedServices: any[] = _(services).where({ appointmentId: service.appointmentId, clientType: service.clientType });
                            let relatedServices: any[] = this.getRelatedUnselectedAppointmentServices(services, [service.appointmentId], null, service.clientType);
                            let msg = this.createPromptForRelatedServices(service, relatedServices, clientsAsked);
                            if (msg) {
                                promises.push(
                                    this.modalService.confirmHandler(msg, Components.Modal.ModalTranslationModes.AsHtml).then((responseIsYes) => {
                                        $.merge(servicesToBeAdded, selectedServices);
                                        if (responseIsYes) {
                                            $.merge(servicesToBeAdded, relatedServices);
                                        }
                                    })
                                );
                            }
                            else {
                                $.merge(servicesToBeAdded, selectedServices);
                            }
                        }
                    });

                    clientIds.forEach((item) => {
                        let service: any = _.findWhere(services, { clientId: item });
                        if (service) {
                            let selectedServices: any[] = _.where(services, { clientId: service.clientId, clientType: service.clientType });
                            // get all unique appointment Ids for the selected services
                            let apptIds: string[] = _.uniq(_.pluck(selectedServices, "appointmentId"));
                            let relatedServices: any[] = this.getRelatedUnselectedAppointmentServices(services, apptIds, service.clientId, service.clientType);
                            let msg = this.createPromptForRelatedServices(service, relatedServices, clientsAsked);
                            if (msg) {
                                promises.push(
                                    this.modalService.confirmHandler(msg, Components.Modal.ModalTranslationModes.AsHtml).then((responseIsYes) => {
                                        $.merge(servicesToBeAdded, selectedServices);
                                        if (responseIsYes) {
                                            $.merge(servicesToBeAdded, relatedServices);
                                        }
                                    })
                                );
                            }
                            else {
                                $.merge(servicesToBeAdded, selectedServices);
                            }
                        }
                    });

                    let d = this.$q.defer<void>();

                    this.$q.all(promises).then(() => {
                        this.getCheckOutDetailsThenAddToRegister(servicesToBeAdded);
                        d.resolve();
                    });

                    return d.promise;
                });
            }
        }

        private getCheckOutDetailsFromServices(services: any[]) {
            const checkOutServices: any[] = [];
            const checkOutDetails: any[] = [];

            if (services && services.length > 0) {
                services.forEach((appointmentService) => {
                    let isCancellation = this.isCancellation(appointmentService);
                    let isNoShow = this.isNoShow(appointmentService);

                    let isRefund = isCancellation || isNoShow;

                    if (isRefund) {
                        if (isCancellation) {
                            if (appointmentService.cancellationAmount > 0) {
                                const cancellationDetail = {
                                    type: Meevo.Model.SalesTypeEnum.ServiceCancellationFee,
                                    cancellationAmount: appointmentService.cancellationAmount,
                                    id: appointmentService.cancellationTypeId || appointmentService.cancellationReasonId,
                                    isPercent: appointmentService.cancellationIsPercent,
                                    applyToAddOns: appointmentService.applyToAddOns, // ???
                                };

                                checkOutServices.push(appointmentService);
                                checkOutDetails.push(cancellationDetail);
                            }
                        }
                        else if (isNoShow) {
                            if (this.registerContext.appointmentNoShowFeePercentage > 0) {
                                const noShowDetail = {
                                    type: Meevo.Model.SalesTypeEnum.ServiceNoShowFee,
                                    fee: this.registerContext.appointmentNoShowFeePercentage,
                                    applyToAddOns: this.registerContext.applyNoShowFeeToAddOns,
                                };

                                checkOutServices.push(appointmentService);
                                checkOutDetails.push(noShowDetail);
                            }
                        }

                        if (appointmentService.depositAmount) {
                            const depositDetail = {
                                type: Meevo.Model.SalesTypeEnum.DepositCredit,
                                appointmentService: appointmentService,
                                appointmentServiceId: appointmentService.id,
                                depositAmount: -Math.abs(appointmentService.depositAmount),
                                serviceShortcut: appointmentService.serviceShortcut,
                                depositLocationId: appointmentService.depositLocationId,
                                depositSaleDate: appointmentService.depositSaleDate,
                                depositSaleId: appointmentService.depositSaleId,
                                depositSaleLineId: appointmentService.depositSaleLineId,
                            }

                            checkOutServices.push(appointmentService);
                            checkOutDetails.push(depositDetail);
                        }
                    } else {
                        checkOutServices.push(appointmentService);
                        checkOutDetails.push({});

                        if (appointmentService.depositAmount) {
                            const depositDetail = {
                                type: Meevo.Model.PaymentSubCategoryEnum.DepositCharge,
                                appointmentService: appointmentService,
                                appointmentServiceId: appointmentService.id,
                                depositAmount: appointmentService.depositAmount,
                                serviceShortcut: appointmentService.serviceShortcut,
                            }

                            checkOutServices.push(appointmentService);
                            checkOutDetails.push(depositDetail);
                        }
                    }
                });
            }

            return {
                checkOutDetails: checkOutDetails,
                checkOutServices: checkOutServices,
            };
        }

        getCheckOutDetailsThenAddToRegister(appointmentServices: any[]) {
            const result = this.getCheckOutDetailsFromServices(appointmentServices);

            this.addSelectedAppointmentsToRegister(result.checkOutServices, result.checkOutDetails);
        }

        addSelectedClientAppointments() {
            this.registerContext.clearSaleSyncAppointmentUpdates();
            let appointmentServiceIds = [];
            let clientIds = [];
            for (var key in this.appointmentSelection) {
                let index = parseInt(key.split("_")[1]);
                let appt = this.clientWithAppointmentsToday.getItemAtIndex(index);
                if (appt.appointmentId) {
                    appointmentServiceIds.push(appt.id);
                }
                else {
                    clientIds.push(appt.clientId);
                }
            }
            this._addSelectedClientAppointments(appointmentServiceIds, clientIds);
        }

        public addClientAppointmentsByInitiatingServiceId(initiatingServiceId: string) {
            this._addSelectedClientAppointments([initiatingServiceId], []);
        }

        clientAppointmentClicked(index) {
            let key = "index_" + index;
            let appt = this.clientWithAppointmentsToday.getItemAtIndex(index);
            if (appt.isSelected) {
                this.appointmentSelection[key] = true;
            }
            else {
                this.appointmentSelection[key] = false;
                delete this.appointmentSelection[key];
            }
        }

        getRelatedUnselectedAppointmentServices(services: any[], appointmentIds: string[], clientId: string, clientType: Meevo.Model.ClientTypeEnum): any[] {
            var relatedApptServices: any[];

            if (clientType === Meevo.Model.ClientTypeEnum.Client) {
                // find all appointment services that is part of the same appointment but either not selected, or client is neither null nor undefined
                relatedApptServices = _.filter(services, (item) => (appointmentIds.indexOf(item.appointmentId) >= 0 && item.clientId != clientId && !item.isSelected));
            }
            else {
                // find all appointment services that is part of the same appointment but either not selected, or client is neither null nor undefined
                relatedApptServices = _.filter(services, (item) => (appointmentIds.indexOf(item.appointmentId) >= 0 && (item.clientType != clientType) && !item.isSelected));
            }

            // remove client's services who are already added in the receipt
            for (var i = relatedApptServices.length - 1; i >= 0; i--) {
                var svc = relatedApptServices[i];
                var rclient: RegisterClient = new RegisterClient({ client: svc.client, clientType: svc.clientType, appointmentId: svc.appointmentId } as Meevo.Model.IRegisterClient);
                if (_.find(this.registerContext.allUniqueClients, (item) => item.isMatch(rclient))) {
                    relatedApptServices.splice(i, 1);
                }
            }

            return relatedApptServices;
        }

        addSelectedAppointmentsToRegister(checkOutServices: any[], checkOutDetails: any[] = []) {
            if (checkOutServices.length > 0) {
                let client = this.registerContext.populateFromAppointmentServices(checkOutServices, checkOutDetails);
                this.registerContext.selectClient(client, true);
                this.populateFromAppointments = true;
            }

            this.clientWithAppointmentsToday.clearSearch();
            this.cancelledOrNoShowAppointments.clearSearch();
            this.appointmentSelection = {};
            this.cancelledOrNoShowAppointmentSelection = {};

            this.registerContext.showToday = false;
        }

        getItemShowName(item: any) {
            return this.$translate.instant(item.clientDisplayName);
        }

        getUniqueClientNames(services: any[], alreadyAskedClientIds?: any[]) {
            let dictionaryOfClientIds = alreadyAskedClientIds ? alreadyAskedClientIds : [];
            let names = [];
            _.each(services, (item) => {
                let key = item.clientType + "_" + item.appointmentId + "_" + (item.clientId ? item.clientId : "");
                if (!dictionaryOfClientIds[key]) {
                    dictionaryOfClientIds[key] = key;
                    names.push(this.getItemShowName(item));
                }
            });
            return names;
        }

        createPromptForRelatedServices(service: any, relatedServices: any[], alreadyAskedClientIds?: any[]) {
            let clientNames = this.getUniqueClientNames(relatedServices, alreadyAskedClientIds);

            if (clientNames.length === 0) {
                return null;
            }

            let message = this.$translate.instant("MESSAGE_RELATED_SERVICES", {
                serviceName: this.getItemShowName(service)
            });

            let html = [ message ];
            html.push('<ul>');
            _(clientNames).each(clientName => {
                html.push('<li>', this.$translate.instant(clientName), '</li>');
            });
            html.push('</ul>');

            return html.join('');
        }

        private getHoldTypes() {
            const holdTypes = [Model.HoldTypeEnum.Register];

            if (this.showRecoveryHolds) {
                holdTypes.push(Model.HoldTypeEnum.Recovery);
            }

            return holdTypes;
        }

        gotoReturnTransaction() {
            if (this.registerContext.editSelectedClient) {
                return;
            }
            if (this.isReturnTransactionDisabled()) {
                return;
            }

            this.securityService.checkSecurityKey(Meevo.Components.Common.SecurityKeys
                .REGISTER_REGISTER_SALEHOLD_ACTION_READLIST)
                .then(result => {
                    if (result === Meevo.Model.SecurityAccessEnum.Grant) {

                        this.showOnHold = true;

                        this.updateReturnTransactionCount();

                        this.onHoldSearchResults = new Meevo.Components.BaseClasses.PagedResults(this.dataService, this.endPoints.saleHold);

                        let request = {
                            pageNumber: 1,
                            itemsPerPage: 20,
                            sortBy: '',
                            sortDirection: Model.SortDirection.Ascending,
                            includeActive: true,
                            includeDeleted: false,
                            includeInactive: false,
                            criteria: {
                                excludeIdList: Object.keys(this.registerContext.sale.onHoldIds),
                                holdTypes: this.getHoldTypes()
                            }
                        };

                        this.onHoldSearchResults.initSearch(request);
                    } else {
                        this.modalService.alert("ERROR_HTTP_403");
                    }
                });
        }

        showRecoveryHoldsChange() {
            this.gotoReturnTransaction();
        }

        retrieveOnHold(onHold) {
            this.registerContext.clearSaleSyncAppointmentUpdates();
            this.securityService.checkSecurityKey(Meevo.Components.Common.SecurityKeys.REGISTER_REGISTER_SALEHOLD_ACTION_VIEW).then(result => {
                if (result !== Meevo.Model.SecurityAccessEnum.Grant) {
                    this.modalService.alert("ERROR_HTTP_403");
                    return;
                }

                this.registerContext.sale.mergeOnHoldId = onHold.id;

                // TODO: unsure why this is here, there is no register sale yet
                console.log('retrieveOnHold');
                this.registerContext.getClientCombinedAfterActions().then(() => {
                    // holds might take a while to come up and screen should not be unprotected
                    this.busyService.start();

                    let selectSection = device.portrait() && !device.largeTablet()
                        ? RegisterSectionTypeEnum.Ticket
                        : RegisterSectionTypeEnum.Services;
                    
                    return this.registerContext.recalculateSale(false, selectSection, true)
                        .finally(() => {
                            this.showOnHold = false;
                            this.busyService.stop();
                        });
                });

                this.dataService.trackUsage(Model.NounEnum.SaleHold, Model.VerbEnum.Selected, null, onHold.id);
            });
        }

        // TODO: this does not appear to be used anywhere
        private getClientsForNotes(clients) {
            var clientList: any[] = [];
            _(clients).each(client => {
                clientList.push({ client: { id: client.id, displayName: client.displayName }});
            });
            return clientList;
        }

        reset() {
            this.showOnHold = false;
            this.showCancelNoShow = false;

            this.updateCounts();
        }

        private updateReturnTransactionCount() {
            let request = {
                criteria: {
                    excludeIdList: this.registerContext.sale ? Object.keys(this.registerContext.sale.onHoldIds) : [],
                    holdTypes: this.getHoldTypes()
                }
            };

            this.dataService.customMethodData(`api/${this.endPoints.saleHold}/Count`, "POST", request).then(response => {
                let counts = response.data;
                this.numberOnHold = counts.onHoldCount - (counts.selfPayCount ? counts.selfPayCount : 0);
                this.numberSelfPay = counts.selfPayCount;
            });

        }

        private updateCancelNoShowCount() {
            this.dataService.getCount("ClientWithCancelledOrNoShowAppointmentService", null).then(count => {
                this.numberCancelNoShow = count;
            });
        }

        private updateCounts() {
            this.updateReturnTransactionCount();
            this.updateCancelNoShowCount();
        }

        gotoCancelNoShow() {
            if (this.registerContext.editSelectedClient) {
                return;
            }
            if (this.isCancelNoShowDisabled()) {
                return;
            }

            this.showCancelNoShow = true;
            this.updateCancelNoShowCount();
            return this.getAllCancelledOrNoShowAppointments();
        }

	    maximumDate = moment().startOf('day').add(1, 'days');
	    minimumDate = moment(this.maximumDate).add(-this.registerContext.cancelNoShowNumberOfDaysBack, 'days');

        minimumDateObj = this.minimumDate.toDate();
        maximumDateObj = this.maximumDate.toDate();

        startDateTime = this.minimumDateObj;
        endDateTime = this.maximumDateObj;
        filterNoShow = true;
        filterCancelledAtNoCharge = false;
        filterCancelledWithCharge = true;
        filterDeposit = false;
        previousFilterDeposit = this.filterDeposit;
        sortBy = 'client';

        startDateTimeChanged() {
            if (moment(this.startDateTime).isBefore(this.minimumDate)) {
                this.startDateTime = this.minimumDateObj;
            }

            this.filterChanged();
        }

        endDateTimeChanged() {
            if (moment(this.endDateTime).isAfter(this.maximumDate)) {
                this.endDateTime = this.maximumDateObj;
            }

            this.filterChanged();
        }

        filterChanged() {
            if (this.filterDeposit != this.previousFilterDeposit) {
                this.previousFilterDeposit = this.filterDeposit;
                if (this.filterDeposit) {
                    this.filterNoShow = true;
                    this.filterCancelledAtNoCharge = true;
                    this.filterCancelledWithCharge = true;
                }
            }

            this.getAllCancelledOrNoShowAppointments();
        }

        getClientsCancelledOrNoShowAppointmentsToday(clientIds: string[] = null, pastTransactionDateTime: Date = null): ng.IPromise<any[]> {
            const startDate = pastTransactionDateTime
                ? moment(pastTransactionDateTime).startOf('day')
                : moment().startOf('day');

            const endDate = moment(startDate).add(1, 'days');

            const request = {
                pageNumber: 0,
                itemsPerPage: 10000,
                sortDirection: Model.SortDirection.Ascending,
                sortBy: "client",
                criteria: {
                    filterNoShow: true,
                    filterCancelledAtNoCharge: true,
                    filterCancelledWithCharge: true,
                    filterDeposit: null,
                    startDate: startDate.toDate(),
                    endDate: endDate.toDate(),
                    clientIds: clientIds
                }
            };

            return this.dataService.customMethodData("api/cancelNoShowAppointmentService/List", "POST", request)
                .then((response) => {
                    // retrieved all but really only want items with fees OR deposits (no way to ask for this from the proc)
                    return _(response.data).filter(item => item.cancellationAmount > 0 || item.depositAmount > 0);
                });
        }

        getAllCancelledOrNoShowAppointments() {
            if (this.filterNoShow || this.filterCancelledAtNoCharge || this.filterCancelledWithCharge || this.filterDeposit) {
                let request = {
                    pageNumber: 0,
                    itemsPerPage: 30,
                    sortDirection: Model.SortDirection.Ascending,
                    sortBy: this.sortBy,
                    criteria: {
                        filterNoShow: this.filterNoShow,
                        filterCancelledAtNoCharge: this.filterCancelledAtNoCharge,
                        filterCancelledWithCharge: this.filterCancelledWithCharge,
                        filterDeposit: this.filterDeposit,
                        startDate: this.startDateTime,
                        endDate: this.endDateTime,
                        clientIds: null
                    }
                }

                this.cancelledOrNoShowAppointments.initSearch(request);
            } else {
                this.cancelledOrNoShowAppointments.clearSearch();
            }
        }

        cancelledOrNoShowAppointmentsPostProcess(count, response, $this) {
            response.forEach((item) => {
                if (!!item.cancellationTypeEnum &&
                    item.cancellationTypeEnum === Meevo.Model.CancellationTypeEnum.OnlineBookingCancellation) {
                        item.cancellationReason = $this.onlineBookingCancellation;
                } else if (!item.cancellationReason) {
                    item.cancellationReason = $this.insertedNoShow;
                }
                item.originalCancellationReason = item.cancellationReason;
            });

            return response;
        }

        cancelledOrNoShowAppointmentClicked(index) {
            let key = "index_" + index;
            let appt = this.cancelledOrNoShowAppointments.getItemAtIndex(index);
            if (appt.isSelected) {
                this.cancelledOrNoShowAppointmentSelection[key] = true;
            }
            else {
                this.cancelledOrNoShowAppointmentSelection[key] = false;
                delete this.cancelledOrNoShowAppointmentSelection[key];
            }
        }

        goBackToClientSelection() {
        }

        addSelectedCancelledOrNoShowAppointments() {
            this.registerContext.clearSaleSyncAppointmentUpdates();
            const appointmentServices = [];

            for (const key in this.cancelledOrNoShowAppointmentSelection) {
                const index = parseInt(key.split("_")[1]);
                const appointmentService = this.cancelledOrNoShowAppointments.getItemAtIndex(index);
                appointmentServices.push(appointmentService);
            }

            const result = this.getCheckOutDetailsFromServices(appointmentServices);

            this.addSelectedAppointmentsToRegister(result.checkOutServices, result.checkOutDetails);
        }

        isNoShowMatched(filter: string): boolean {
            let isMatched = (filter.length === 0);
            if (!isMatched) {
                let pattern = filter.replace("_", ".").replace("%", "");
                let re = new RegExp(pattern, "i");
                isMatched = re.test(this.insertedNoShow.displayName);
            }
            return isMatched;
        }

        deleteCancelNoShow(appointmentService) {
            let request = {
                appointmentEntityVersion: appointmentService.appointmentEntityVersion,
                model: {
                    IsFeeExempt: true
                }
            };
            this.dataService.patch(`Appointment/${appointmentService.appointmentId}/AppointmentService/${appointmentService.id}`, request).then(response => {
                this.getAllCancelledOrNoShowAppointments();
                this.updateCancelNoShowCount();
            })
        }

        cancellationTypePreProcessData(responseData, requestData): any[] {
            if (requestData.pageNumber === 0) {
                if (this.isNoShowMatched(requestData.criteria.filter)) {
                    responseData.splice(0, 0, this.insertedNoShow);
                }
                return responseData;
            }
            return null;
        }

        cancellationTypeChanged(appt) {
            if (!appt.cancellationReason) {
                return;
            }

            if (appt.cancellationReason.id == this.insertedNoShow.id) {
                appt.cancellationReason = appt.originalCancellationReason;
                return;
            }

            if (appt.cancellationReason.id == appt.cancellationTypeId) {
                return;
            }

            let request = {
                appointmentEntityVersion: appt.appointmentEntityVersion,
                model: {
                    FinalState: Meevo.Model.AppointFinalStateEnum.Cancelled,
                    CancellationReasonId: appt.cancellationReason.id,
                    CancellationType: Meevo.Model.CancellationTypeEnum.UserDefined
                }
            };

            appt.isDisabled = true;
            this.dataService.patch(`Appointment/${appt.appointmentId}/AppointmentService/${appt.id}`, request)
                .then(() => {
                    this.getAllCancelledOrNoShowAppointments();
                })
                .catch(() => {
                    appt.cancellationReason = appt.originalCancellationReason;
                })
                .finally(() => {
                    appt.isDisabled = false;
                });
        }

        isCheckOutDisabled(): boolean {
            return Object.keys(this.registerContext.sale.onHoldIds).length === 0;
        }

        isCancelledOrNoShowCheckOutDisabled(): boolean {
            return Object.keys(this.cancelledOrNoShowAppointmentSelection).length === 0;
        }

        isCancelledOrNoShowCheckboxDisabled(appointmentService): boolean {
            return !this.hasFee(appointmentService) && !this.hasDeposit(appointmentService);
        }

        isCancellation(appointmentService): boolean {
            if (!appointmentService) {
                return false;
            }

            return appointmentService.finalState === Meevo.Model.AppointFinalStateEnum.Cancelled ||
                   (appointmentService.cancellationReason && appointmentService.cancellationReason.id != this.insertedNoShow.id);
        }

        isNoShow(appointmentService): boolean {
            if (!appointmentService) {
                return false;
            }

            return (appointmentService.transitionState === Meevo.Model.AppointStateEnum.NoShow &&
                    appointmentService.finalState === Meevo.Model.AppointFinalStateEnum.None) ||
                   (appointmentService.cancellationReason && appointmentService.cancellationReason.id == this.insertedNoShow.id);
        }

        hasFee(appointmentService): boolean {
            return appointmentService && appointmentService.cancellationAmount > 0;
        }

        hasDeposit(appointmentService): boolean {
            return appointmentService && appointmentService.depositAmount;
        }

        private checkForClientMissingFieldAlert(id, clientAlertsArray) {
            if (!id) { // check if id is null or undefined or empty
                return;
            }

            let uri = '/api/Client/' + id + '/Alerts/';
            this.dataService.customMethodData(uri, "GET", null)
                .then((response) => {
                    $.each(response.data, (index, alertmsg) => {
                        if (alertmsg.clientAlertType === Meevo.Model.ClientAlertTypeEnum.HasNotes || alertmsg.clientAlertType === Meevo.Model.ClientAlertTypeEnum.HasActiveGiftCard) {
                            return;
                        }
                        clientAlertsArray.push(<PassiveAlert>{
                            alertMessage: this.registerContext.clientAlertMsg[alertmsg.clientAlertType],
                            alertPriorityLevel: Meevo.Model.AlertPriorityLevelEnum.Normal,
                            alertClick: () => {
                                this.registerContext.openClient(this.registerContext.selectedClient, alertmsg.clientAlertType, this.clientCallback());
                            }
                        });
                    });
                });
        }

        clientCallback() {
            return () => {
                this.registerContext.selectedClient.clientAlerts = [];
                this.checkForClientMissingFieldAlert(this.registerContext.selectedClient.id, this.registerContext.selectedClient.clientAlerts);
            };
        }

        resendSelfPayment(onHold) {
            this.dataService.getItem("salehold", onHold.id).then(sale => {
                let options: Meevo.Components.Modal.IModalOptions = {
                    templateUrl: "app/plugins/register/modals/selfPaymentModal.template.html",
                    controller: "meevo.plugins.register.SelfPaymentModalController",
                    controllerAs: "vm",
                    bindToController: true,
                    locals: {
                        selfPaymentId: onHold.selfPaymentId,
                        registerContext: this.registerContext,
                        sale: sale
                    }
                }
                this.modalService.showCustom(options).then(res => {
                    if (res) {
                        this.gotoReturnTransaction();
                    }
                });
            })

        }

        getSelfPayTimeLeftMessage(selfPaymentHoursRemaining: number) {
            if (selfPaymentHoursRemaining > 1) {
                var roundedHours = Math.round(selfPaymentHoursRemaining);
                return roundedHours > 1 
                    ? this.$translate.instant('LABEL_SELFPAY_EXPIRES_IN_HOURS', {hours: roundedHours})
                    : this.$translate.instant('LABEL_SELFPAY_EXPIRES_IN_HOUR');
            }

            if (selfPaymentHoursRemaining > 0) {
                return this.$translate.instant('LABEL_SELFPAY_EXPIRES_IN_LESS_THAN_1_HOUR');
            }
        }

        checkRefundDisabledAlert() {
            if (this.isRefundTransactionDisabled()) {
                this.modalService.alert(this.$translate.instant('MESSAGE_UNABLE_INSERT_REFUND_PAST_TRANSACTION'));
            }
        }

        refundTransaction(scannedTransactionId) {
            this.registerContext.getSaleLinesToRefundFromTransactionId(scannedTransactionId);
        }
    }
}